export const ALL_ADMIN_ROLES = [
  "GENSEC_SCITECH",
  "GENSEC_ACADEMIC",
  "GENSEC_CULTURAL",
  "GENSEC_SPORTS",
  "PRESIDENT",
];

export const genSecRoles = [
  { path: "cult", role: "GENSEC_CULTURAL" },
  { path: "sport", role: "GENSEC_SPORTS" },
  { path: "acad", role: "GENSEC_ACADEMIC" },
  { path: "tech", role: "GENSEC_SCITECH" },
];
